import appStore from '@stores/appStore'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'

type ContextType = {
  storeKey?: string
  contextLoading: boolean
  setContextLoading: (val: boolean) => void
}

export const StoreContext = React.createContext<ContextType>({
  storeKey: null,
  contextLoading: false,
  setContextLoading: () => {},
})

function StoreContextWrapper({
  children,
  storeKey,
}: {
  children: React.ReactNode
  storeKey: string
}) {
  const [contextLoading, setContextLoading] = useState(false)

  const contextValue = useMemo(() => {
    return {
      storeKey,
      contextLoading,
      setContextLoading,
    }
  }, [storeKey, contextLoading])

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  )
}

export default StoreContextWrapper

export const useStoreContext = () => useContext(StoreContext)
